module.exports = __webpack_public_path__ + "Roboto-ThinItalic.8a2c1a5de09de8bb2c45.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-ThinItalic.woff2
// module id = 134
// module chunks = 17